import { Flex, SegmentedControl } from '@cognite/cogs.js-v10';
import { AppConfigUseFlagContext } from '@infield/features/app-config/app-config-use-flag.context';
import { LOCIZE_NAMESPACES } from '@infield/features/i18n';
import { useTranslation } from '@infield/features/i18n';
import { useDeviceContext } from '@infield/providers/device-provider';
import type { KeyboardType } from '@infield/providers/device-provider/device-context';
import { type FC, useContext } from 'react';

import * as S from '../elements';

import { InputKeyboardTester } from './input-keyboard-tester';

export const DeviceTabKeyboardSelector: FC = () => {
  const { t } = useTranslation(LOCIZE_NAMESPACES.user);

  const { keyboardMode, setKeyboardModeManually, keyboardConfig } =
    useDeviceContext();

  const handleOnKeyboardChange = (selected: KeyboardType) => {
    if (keyboardMode !== selected) {
      setKeyboardModeManually(selected satisfies KeyboardType);
    }
  };
  return (
    <Flex direction="column" style={{ gap: '24px' }}>
      {/* Keyboard Mode Selector */}
      <h4>
        {t(
          'USER_PROFILE_KEYBOARD_TESTER_TITLE',
          'Select mobile keyboard for numerical reading'
        )}
      </h4>
      <SegmentedControl
        fullWidth
        currentKey={keyboardMode}
        onButtonClicked={handleOnKeyboardChange}
        style={{ marginTop: '24px !important' }}
      >
        <S.ControlButton key="IOS">
          {t('USER_PROFILE_KEYBOARD_IOS_OPTION', 'IOS')}
        </S.ControlButton>
        <S.ControlButton key="ANDROID">
          {t('USER_PROFILE_KEYBOARD_MODE_ANDROID_OPTION', 'Android')}
        </S.ControlButton>
        <S.ControlButton key="WINDOWS">
          {t('USER_PROFILE_KEYBOARD_MODE_WINDOWS_OPTION', 'Windows')}
        </S.ControlButton>
        <S.ControlButton key="DEFULT">
          {t('USER_PROFILE_KEYBOARD_DEFULT_OPTION', 'Default')}
        </S.ControlButton>
      </SegmentedControl>
      <InputKeyboardTester />
    </Flex>
  );
};
